import { RootState } from '../../../rootReducer';
import { EditConnectorState } from './types';

export const selectEditConnectorState = (state: RootState): EditConnectorState =>
  state.connectors.edit;
